import store from '~/store'

export default async (to, from, next) => {

  if (!store.getters['auth/check']) {
    next({ name: 'login' })
  } else {
      // USER PAGO
      if (store.getters['auth/user'].venc_plano) {
          // Hoje
          let dataAtual = moment();
          //30 dias de tolerancia após do vencimento
          let dataBloqueio = moment(store.getters['auth/user'].venc_plano).add(5, 'days')
          // console.log(dataBloqueio);
          if (dataAtual > dataBloqueio) {
            next({ name: 'bloqueio' }) // falta de pagamento
          } else {
                // carregar configuração do usuário pago - igual em abaixo
                if (store.state.auth.user.config) {
                   if (!store.state.config.user_config.termo_paciente.sing) {
                     store.dispatch('config/loadConfigUser')
                     next()
                   }else {
                     next()
                   }
                }else {
                    next({ name: 'ConfigContaUserHome' })
                }
          }
     // USER GRÁTIS
      }else{
              //  carregar configuração do usuário grátis - igual em cima
              if (store.state.auth.user.config) {
                 if (!store.state.config.user_config.termo_paciente.sing) {
                   store.dispatch('config/loadConfigUser')
                   next()
                 }else {
                   next()
                 }
              }else {
                  next({ name: 'ConfigContaUserHome' })
              }
      }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/middleware/auth.js